// components/steps/StepHotel.jsx
import React from 'react';

const StepHotel = ({ data, updateData, skip, goBack }) => {
  return (
    <div className="bg-white/60 backdrop-blur p-6 rounded-xl shadow-lg">
      <h2 className="text-xl font-semibold mb-4">Do you have a hotel reservation?</h2>
      <div className="flex justify-between gap-4 mb-6">
        <button
          onClick={() => updateData('hasHotelReservation', true)}
          className="flex-1 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
        >
          Yes
        </button>
        <button
          onClick={() => updateData('hasHotelReservation', false)}
          className="flex-1 bg-gray-300 text-black px-4 py-2 rounded-lg hover:bg-gray-400 transition"
        >
          No
        </button>
      </div>

      {/* Navigation buttons */}
      <div className="flex justify-between items-center">
        {goBack && (
          <button
            onClick={goBack}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
          >
            Back
          </button>
        )}
        <button
          onClick={skip}
          className="px-6 py-2 bg-transparent border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition"
        >
          Skip
        </button>
      </div>
    </div>
  );
};

export default StepHotel;